export default __webpack_public_path__ + "9bc54b7c2e18a934c6ffdc0f34499c61.png";